<template>
  <div>
    <Modal v-model="recordsModal" width="60%">
      <p slot="header" class="text-center">查看导入记录</p>
      <Table
        stripe
        max-height="620"
        size="small"
        :data="recordList"
        :columns="recordColumns"
        :loading="recordLoading"
      >
      </Table>
      <div class="paging_style">
        <Page
          size="small"
          :total="total"
          :page-size="query.pageSize"
          show-total
          show-elevator
          :current="query.pageNumber"
          @on-change="onChangePageNum"
        ></Page>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPlayListRecord } from '@/api/msp/playList'
export default {
  data () {
    return {
      recordsModal: false,
      query: {
        pageNumber: 1,
        pageSize: 15
      },
      recordList: [],
      total: 0,
      recordLoading: false,
      recordColumns: [
        { title: '导入时间', align: 'center', minWidth: 120, key: 'createTime' },
        {
          title: '文件地址',
          align: 'center',
          minWidth: 120,
          key: 'filePath',
          render: (h, { row }) => {
            return h('a', {
              on: {
                click: () => {
                  window.open(row.filePath, '_blank')
                }
              }
            }, row.filePath)
          }
        },
        { title: '状态', align: 'center', minWidth: 120, key: 'statusName' },
        { title: '备注', align: 'center', minWidth: 120, key: 'remark' },
        { title: '操作人', align: 'center', minWidth: 120, key: 'userName' }
      ]
    }
  },
  methods: {
    show () {
      this.recordsModal = true
      this.getData()
    },
    getData () {
      this.recordLoading = true
      getPlayListRecord(this.query).then(res => {
        if (res && !res.errcode) {
          this.recordList = res.list
          this.total = res.totalRow
        } else {
          this.recordList = []
          this.total = 0
        }
      }).finally(() => { this.recordLoading = false })
    },
    onChangePageNum (curPage) {
      this.query.pageNumber = curPage
      this.getData()
    }
  }
}
</script>
